import { InputDate } from "#common/input/InputDate"
import CircularSkeleton from "#common/skeleton/CircularSkeleton"
import { DialogMaster } from "#core/components/dialog/Dialog"
import InputSelect from "#core/components/input/select/InputSelect"
import { TableMain } from "#core/components/table-main/TableMain"
import ErrorResponse from "#core/pages/ErrorResponse"
import { useApi } from "#hooks/useApi"
import { useApiSend } from "#hooks/useApiSend"
import {
	evaluationActionPlanPost,
	evaluationIdGet,
} from "#performance-evaluation/services/api"
import { Box, Button, Divider, TextField } from "@mui/material"
import { useReloadRefresh } from "app/reload"
import { useMemo, useState } from "react"
import { toast } from "react-toastify"

export default function ActionPlanForm({ autoFetch, evaluationId, values, setValues }) {
	const params = useMemo(
		() => ({
			id: evaluationId,
			params: { competences: true },
		}),
		[evaluationId],
	)

	const { data, loading, error } = useApi(evaluationIdGet, {
		autoFetch,
		params,
	})
	const competencias = useMemo(() => {
		const dataCompetencias = data?.competencies || []
		return dataCompetencias
	}, [data?.competencies])
	console.log("🚀 ~ ActionPlanForm ~ competencias:", competencias)

	const [newItem, setNewItem] = useState({
		competencia: "",
		commitment_date: null,
		objective: "",
		actions: "",
	})

	const handleFieldText = (field) => {
		const setValue = (e) => {
			const value = e.target.value
			setNewItem((prev) => ({
				...prev,
				[field]: value,
			}))
		}
		return { value: newItem[field], onChange: setValue }
	}

	const items = [
		{ name: "competencia_name", label: "Competencia" },
		{ name: "objective", label: "objetivo" },
		{ name: "actions", label: "acciones" },
		{ name: "commitment_date", label: "Fecha compromiso" },
	]

	if (loading) return <CircularSkeleton />
	if (error) return <ErrorResponse api={error} />

	return (
		<Box display="flex" gap={2} flexDirection={"column"} height={"90vh"}>
			<Box display="flex" flexDirection="column" gap={0.5} p={0.5} alignItems={"center"}>
				<Box
					display="flex"
					flexDirection="row"
					gap={1}
					p={0.5}
					width={"100%"}
					justifyContent={"center"}
					justifyItems={"center"}
					alignItems={"flex-end"}
				>
					<InputSelect
						options={competencias}
						optionsId={"id"}
						optionsLabel={"info"}
						label="Competencia"
						fullWidth
						value={newItem.competencia}
						setValue={(val) => {
							console.log("🚀 ~ ActionPlanForm ~ val:", val)
							const competencia_name = competencias.find((c) => c.id === val)?.info
							setNewItem((old) => ({ ...old, competencia: val, competencia_name }))
						}}
					/>
					<Box width={"20%"}>
						<InputDate
							label="Fecha Compromiso"
							fullWidth
							value={newItem.commitment_date}
							onChange={(date) =>
								setNewItem((old) => ({
									...old,
									commitment_date: date?.format("YYYY-MM-DD"),
								}))
							}
						/>
					</Box>
				</Box>
				<Box display="flex" flexDirection="row" gap={1} p={0.5} width={"100%"}>
					<TextField
						rows={2}
						multiline
						label="Objetivo"
						fullWidth
						{...handleFieldText("objective")}
					/>
					<TextField
						rows={2}
						multiline
						label="Acciones"
						fullWidth
						{...handleFieldText("actions")}
					/>
				</Box>
				<Button
					onClick={() => {
						if (!validateItem(newItem)) return
						setValues((prev) => [...prev, newItem])
						setNewItem({
							competencia: "",
							commitment_date: null,
							objective: "",
							actions: "",
						})
					}}
				>
					Agregar
				</Button>
			</Box>
			<Divider />
			<Box height={"11vh"}>
				<TableMain items={items} data={values} />
			</Box>
		</Box>
	)
}

export const ActionPlanFormDialog = ({ open, setOpen, evaluationId }) => {
	const [values, setValues] = useState([])
	const [disabled, setDisabled] = useState(false)
	const { refresh } = useReloadRefresh()
	const success = () => {
		refresh()
		setOpen(false)
	}
	const end = () => {
		setDisabled(false)
	}
	const { fetch } = useApiSend(evaluationActionPlanPost, { success, end })
	const handleSubmit = () => {
		setDisabled(true)
		fetch({ evaluation_id: evaluationId, action_plan: values })
	}
	return (
		<DialogMaster
			{...{
				open,
				setOpen,
				title: "Crear plan de acción",
				maxWidth: "xl",
				handleSubmit,
				disabled,
			}}
		>
			<ActionPlanForm {...{ evaluationId, values, setValues, autoFetch: open }} />
		</DialogMaster>
	)
}

const validateItem = (data) => {
	const items = [
		{ label: "Competencias", id: "competencia" },
		{ label: "Fecha de compromiso", id: "commitment_date" },
		{ label: "Objetivo", id: "objective" },
		{ label: "Acciones", id: "actions" },
	]
	for (let item of items) {
		if (!data[item.id] || data[item.id] === "") {
			toast.error(`El campo ${item.label} es obligatorio`)
			return
		}
	}
	return true
}
